/**
 * NewsCommon.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 서버 API로부터 관심고객 데이터를 전달 및 요청할 수 있도록 제어하는 기본 통신 로직이 정의.
 *
 * -----------------------------------------------------------------------------------------------
 */

import { getWatchList, editWatchList, getWatchListMore } from 'common-modules/general/API/watchlist';
import { RequestEditWatchList, ResponseResultCode, ResponseDetailWatch, ResponseWatchlist } from 'common-modules/general/API/watchlist/types';
import MobxAsyncModel from 'common-modules/general/Model/MobxAsyncModel';
import MobxStore from 'common-modules/general/Store/MobxStore';
import { makeAutoObservable } from 'mobx';

export default class WatchListCommonModel {
  public mainData: MobxAsyncModel<ResponseWatchlist[]>;
  public moreData: MobxAsyncModel<ResponseDetailWatch>;
  public editDataModel: MobxAsyncModel<ResponseResultCode>;
  public moveRouter: string | null;

  constructor() {
    this.mainData = new MobxAsyncModel(true);
    this.moreData = new MobxAsyncModel(true);
    this.editDataModel = new MobxAsyncModel();
    this.moveRouter = null;

    makeAutoObservable(this);
  }

  setMoveRouter = router => {
    this.moveRouter = router;
  };

  getData = () => {
    getWatchList()
      .then(({ data }) => {
        this.mainData.loadSuccess(data);
      })
      .catch(() => {
        this.mainData.loadFailure();
      });
  };

  getDataMore = () => {
    getWatchListMore()
      .then(({ data }) => {
        this.moreData.loadSuccess(data);
      })
      .catch(() => {
        this.moreData.loadFailure();
      });
  };

  editData = (params: RequestEditWatchList['watchList'], type: 'P' | 'M', agree?: any, ynAgrtAgrt?: any) => {
    return new Promise<void>((resolve, reject) => {
      editWatchList(params, type, agree, ynAgrtAgrt)
        .then(({ data }) => {
          this.editDataModel.loadSuccess(data);
          this.getData();
          this.getDataMore();
          
          if (agree && (agree.ynSmsRcpn || agree.ynEmailRcpn)) {
            const { authManager } = MobxStore();
            authManager.updateUserdata('ynSmsRcpn', agree.ynSmsRcpn);
            authManager.updateUserdata('ynEmailRcpn', agree.ynEmailRcpn);
          }
          resolve();
        })
        .catch(error => {
          this.editDataModel.loadFailure();
          reject(error?.response);
        });
    });
  };
}
